import Vue from 'vue';

import {Enum} from '@/app/shared/enum/enum';

export const broadcast = new Vue();

export class Broadcast {
  onCodeRefresh() {
    broadcast.$emit('CODE_REFRESH');
  }

  onModalOpen(modal: Enum.CORE.MODAL) {
    broadcast.$emit(
      Enum.CORE.MODAL.MODAL_OPEN,
      modal
    );
  }

  onSpinner(useYn: boolean) {
    broadcast.$emit(
      Enum.CORE.SPINNER.DEFAULT,
      useYn
    );
  }

  onError() {
    broadcast.$emit(Enum.CORE.SPINNER.SPINNER_ERROR);
  }
}
